{
    "locale": "fr",
    "nationalities": {
        "AF": "Afghan",
        "AL": "Albanais",
        "DZ": "Algérien",
        "AD": "Andorran",
        "AO": "Angolais",
        "AG": "Antiguayen",
        "AR": "Argentin",
        "AM": "Arménien",
        "AU": "Australien",
        "AT": "Autrichien",
        "AZ": "Azerbaïdjanais",
        "BS": "Bahamien",
        "BH": "Bahreïnien",
        "BD": "Bangladais",
        "BB": "Barbadien",
        "BY": "Biélorusse",
        "BE": "Belge",
        "BZ": "Bélizien",
        "BJ": "Béninois",
        "BM": "Bermudien",
        "BT": "Bhoutanais",
        "BO": "Bolivien",
        "BA": "Bosnien",
        "BW": "Botswanais",
        "BV": "Île Bouvet",
        "BR": "Brésilien",
        "IO": "Territoire britannique de l'océan Indien",
        "BN": "Brunéien",
        "BG": "Bulgare",
        "BF": "Burkinabé",
        "BI": "Burundais",
        "KH": "Cambodgien",
        "CM": "Camerounais",
        "CA": "Canadien",
        "CV": "Cap verdien",
        "KY": "Caïmanien",
        "CF": "Centrafricain",
        "TD": "Tchadien",
        "CL": "Chilien",
        "CN": "Chinois",
        "CX": "L'île Christmas",
        "CC": "Îles Cocos",
        "CO": "Colombien",
        "KM": "Comorien",
        "CG": "Congolais",
        "CD": "Congolais",
        "CK": "Îles Cook",
        "CR": "Costaricain",
        "CI": "Ivoirien",
        "HR": "Croate",
        "CU": "Cubain",
        "CY": "Chypriote",
        "CZ": "Tchèque",
        "DK": "Danois",
        "DJ": "Djiboutien",
        "DM": "Dominicain",
        "DO": "Dominicain",
        "EC": "Équatorien",
        "EG": "Égyptien",
        "SV": "Salvadorien",
        "GQ": "Équato-guinéen",
        "ER": "Érythréen",
        "EE": "Estonien",
        "ET": "Éthiopien",
        "FK": "Malouin",
        "FO": "Féroïen",
        "FJ": "Fidjien",
        "FI": "Finlandais",
        "FR": "Français",
        "GF": "Français",
        "PF": "Français",
        "TF": "Français",
        "GA": "Gabonais",
        "GM": "Gambien",
        "GE": "Géorgien",
        "DE": "Allemand",
        "GH": "Ghanéen",
        "GI": "Gibraltariens",
        "GR": "Grec",
        "GL": "Groenlandais",
        "GD": "Grenadien",
        "GP": "Guadeloupéen",
        "GU": "Guam",
        "GT": "Guatémaltèque",
        "GN": "Guinéen",
        "GW": "Bissaoguinéen",
        "GY": "Guyanais",
        "HT": "Haïtien",
        "HM": "Îles Heard-et-MacDonald",
        "VA": "Saint-Siège (État de la cité du Vatican)",
        "HN": "Hondurien",
        "HK": "Hongkongais",
        "HU": "Hongrois",
        "IS": "Islandais",
        "IN": "Indien",
        "ID": "Indonésien",
        "IR": "Iranien",
        "IQ": "Irakien",
        "IE": "Irlandais",
        "IL": "Israélien",
        "IT": "Italien",
        "JM": "Jamaïquain",
        "JP": "Japonais",
        "JO": "Jordanien",
        "KZ": "Kazakhstanais",
        "KE": "Kényan",
        "KI": "Kiribatiens",
        "KP": "Nord coréen",
        "KR": "Sud coréen",
        "KW": "Koweïtien",
        "KG": "Kirghiz",
        "LA": "Laotien",
        "LV": "Letton",
        "LB": "Libanais",
        "LS": "Mosotho",
        "LR": "Liberian",
        "LY": "Libyen",
        "LI": "Liechtensteinois",
        "LT": "Lituanien",
        "LU": "Luxembourgeois",
        "MO": "Macanéen",
        "MG": "Malgache",
        "MW": "Malawien",
        "MY": "Malaisien",
        "MV": "Maldivien",
        "ML": "Malien",
        "MT": "Maltais",
        "MH": "Marshallais",
        "MQ": "Martiniquais",
        "MR": "Mauritanien",
        "MU": "Mauricien",
        "YT": "Mahorais",
        "MX": "Mexicain",
        "FM": "Micronésien",
        "MD": "Moldave",
        "MC": "Monégasque",
        "MN": "Mongol",
        "MS": "Montserratien",
        "MA": "Marocain",
        "MZ": "Mozambicain",
        "MM": "Birman",
        "NA": "Namibien",
        "NR": "Nauruan",
        "NP": "Népalais",
        "NL": "Néerlandais",
        "NC": "Néo-Calédonien",
        "NZ": "Néo-Zélandais",
        "NI": "Nicaraguayen",
        "NE": "Nigérian",
        "NG": "Nigérien",
        "NU": "Niuéen",
        "NF": "Norfolkais",
        "MK": "Macédonien",
        "MP": "Îles Mariannes du Nord",
        "NO": "Norvégien",
        "OM": "Omanais",
        "PK": "Pakistanais",
        "PW": "Palauan",
        "PS": "Territoires Palestiniens, Occupés",
        "PA": "Panaméen",
        "PG": "Papouasien",
        "PY": "Paraguayen",
        "PE": "Péruvien",
        "PH": "Philippin",
        "PN": "Îles Pitcairn",
        "PL": "Polonais",
        "PT": "Portugais",
        "PR": "Portoricain",
        "QA": "Qatarien",
        "RE": "Réunionnais",
        "RO": "Roumain",
        "RU": "Russe",
        "RW": "Rwandais",
        "SH": "Sainte Hélène",
        "KN": "Afro-Kittitien et Afro-Nevisien",
        "LC": "Saint-Lucien",
        "PM": "Saint-Pierrais ou Miquelonais",
        "VC": "Vincentais",
        "WS": "Samoan",
        "SM": "Saint-Marinais",
        "ST": "Santoméen",
        "SA": "Saoudien",
        "SN": "Sénégalais",
        "SC": "Seychellois",
        "SL": "Sierra Léonais",
        "SG": "Singapourien",
        "SK": "Slovaque",
        "SI": "Slovène",
        "SB": "Salomonais",
        "SO": "Somalien",
        "ZA": "Sud Africain",
        "GS": "Géorgie du Sud et les îles Sandwich du Sud",
        "ES": "Espanol",
        "LK": "Sri Lankais",
        "SD": "Soudanais",
        "SR": "Surinamais",
        "SJ": "Svalbard et Jan Mayen",
        "SZ": "Swazi",
        "SE": "Suédois",
        "CH": "Suisse",
        "SY": "Syrien",
        "TW": "Taïwanais",
        "TJ": "Tadjik",
        "TZ": "Tanzanien",
        "TH": "Thaïlandais",
        "TL": "Est-Timorais",
        "TG": "Togolais",
        "TK": "Tokélaou",
        "TO": "Tongien",
        "TT": "Trinidadien ou Tobagonien",
        "TN": "Tunisien",
        "TR": "Turc",
        "TM": "Turkmène",
        "TC": "Îles Turques-et-Caïques",
        "TV": "Tuvalais",
        "UG": "Ougandais",
        "UA": "Ukrainien",
        "AE": "Émirien",
        "GB": "Britanique",
        "US": "Américain",
        "UM": "Îles mineures éloignées des États-Unis",
        "UY": "Uruguayen",
        "UZ": "Ouzbek",
        "VU": "Vanuatais",
        "VE": "Vénézuélien",
        "VN": "Vietnamien",
        "VG": "Îles Vierges Britanniques",
        "VI": "Îles Vierges Américaines",
        "WF": "Gallois",
        "EH": "Sahara Occidental",
        "YE": "Yéménite",
        "ZM": "Zambien",
        "ZW": "Zimbabwéen",
        "AX": "Îles Aland",
        "BQ": "Pays-Bas Caribéens",
        "CW": "Curacien",
        "GG": "Guernesiais",
        "IM": "Île de Man",
        "JE": "Jersiais",
        "ME": "Monténégrin",
        "BL": "Saint-Barthélemy",
        "MF": "Saint-Martinois (France)",
        "RS": "Serbe",
        "SX": "Saint-Martinois (Pays-Bas)",
        "SS": "Sud-Soudanais",
        "XK": "Kosovar"
    }
}